import { Serializers, SerializerValue } from "@megaron/serializers";

export const cartFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  isArchived: Serializers.boolean,
  isFulfilled: Serializers.boolean,
  hasRewards: Serializers.boolean,
  excludeEmpty: Serializers.boolean,
  searchTerm: Serializers.string,
}).partial();

export type CartFilters = SerializerValue<typeof cartFiltersSerializer>;
